import { Outlet } from "react-router-dom";
import { useEffect } from "react";

const Investigation = () => {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default Investigation;
